import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { IDENTIFICATION_TOKEN } from '../EarlyRequesterNames';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const ENDPOINT = 'helpdesk-integration/v1/messages/tokens/create';
export const fetchIdentificationToken = () => {
  return http.post(ENDPOINT);
};
export const GET_IDENTIFICATION_TOKEN = registerQuery({
  fieldName: 'identificationToken',
  args: [],
  fetcher() {
    return getEarlyRequestResult(IDENTIFICATION_TOKEN, fetchIdentificationToken);
  }
});